
















































import Vue from 'vue'
import axios from 'axios'
import { ApiService } from '../../core/services/api'

export default Vue.extend({

  data: () => ({
    info: null
  }),

  async mounted () {

    // let api = new ApiService('api/auth/token');
    // this.info = await api.fetch();

    /* axios.get('https://api.coindesk.com/v1/bpi/currentprice.json')
     .then(response => (this.info = response.data.bpi))
     .catch(error => console.log(error));
     */
  }

  /* methods: {
    getToken: function () {
      this.message = this.message.split('').reverse().join('')
    }
  } */

})
